const rewardsCertificateUrl = "/v1/credit/accounts/rewards/certificate";
export {
  rewardsCertificateUrl
};
//# sourceMappingURL=endpoints.js.map
